import type { MaintenanceScheduleRangeType } from '@/app/components/sections/service/maintenance-list/types';
import { formatPrice } from '@/app/utils/format';

const regexParsedFormat = /[\s~`!@#$%^&*(){}\[\];:"'<,.>?\/\\|+=ก-๛]/g;
export const getParsedFormat = (data: string | undefined) => {
  if (!data) return '';
  return data.replace(regexParsedFormat, '').toLowerCase();
};

export const getRangeSelectOptionLabel = (item: MaintenanceScheduleRangeType) =>
  `${item.month} เดือน หรือ ${formatPrice(item.mileage, 'none')} กม.`;

export const getRangeSelectOptionValue = (item: MaintenanceScheduleRangeType) =>
  `${item.month}-${item.mileage}`;

export const getPriceFormat = (data: {
  price: number;
  unit?: string;
  isDiscount?: boolean;
}) => {
  const unitSuffix = data.unit ? ` ${data.unit}` : '';
  if (!data.price || `${data.price}` === '-') return '0' + unitSuffix;

  let price = formatPrice(data.price, 'none');
  if (data.isDiscount) {
    price = price.charAt(0).includes('-')
      ? `- ${price.slice(1)}`
      : `- ${price}`;
  }
  return price + unitSuffix;
};

export const getScheduleSelectOptionValue = (
  item: MaintenanceScheduleRangeType
) => `${item.month}-${item.mileage}`;
